import React from 'react';
import IconBase from 'react-icons/IconBase';

export const PlusIcon = props => (
  <IconBase viewBox="0 0 32 32" {...props}>
    <path
      d="M17.6 0H14.4V14.4H0V17.6H14.4V32H17.6V17.6H32V14.4H17.6V0Z"
      fill="white"
    />
  </IconBase>
);
